import script from "./headerAir.vue?vue&type=script&setup=true&lang=js"
export * from "./headerAir.vue?vue&type=script&setup=true&lang=js"

import "./headerAir.vue?vue&type=style&index=0&id=2426612a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2426612a"]])

export default __exports__